import CustomerView from 'models/location/customer_view';
import requestCustomerExtension from 'actions/external_customer_lookup/request_customer_extension';
import reloadExternalData from 'actions/external_data/reload_external_data';

export default class RefreshExternalCustomerData {
  constructor(context) {
    this.context = context;
  }

  run({ shouldRequestCustomerExtension, shouldRequestExternalData }) {
    const currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof CustomerView)) {
      return;
    }

    if (shouldRequestCustomerExtension) {
      requestCustomerExtension(this.context, currentLocation.customerId);
    }

    if (shouldRequestExternalData) {
      reloadExternalData(this.context, currentLocation.customerId, true);
    }

    this.context.analytics.track('Customer Profile Data Refreshed', {
      customerId: currentLocation.customerId,
    });
  }
}
